export const NEWS_FIELD_FILE = 'main_file_id';
export const NEWS_FIELD_FILES = 'files';
export const NEWS_FIELD_TITLE = 'title_json';
export const NEWS_FIELD_TYPE = 'type';
export const NEWS_FIELD_CONTENT = 'content_json';
export const NEWS_FIELD_ADDITIONAL_FILES = '"additional_files"';
export const NEWS_PUBLISH_DATE = 'publish_date';
